import { localStorageUtils } from '../storage/localStorage';
import { STORAGE_KEYS } from '../../constants/storage/storage';
import { ONE_HOUR_IN_MILLISECONDS } from '../../constants/app/times';

export const getTargetDate = (): number => {
  const savedTime = localStorageUtils.getNumberItem(
    STORAGE_KEYS.COUNTDOWN_TIMER,
    0
  );
  if (savedTime) {
    const timeLeft = Date.now() < savedTime;
    if (timeLeft) {
      return savedTime;
    }
    return 0;
  } else {
    const targetDate = Date.now() + ONE_HOUR_IN_MILLISECONDS;
    localStorageUtils.setItem(STORAGE_KEYS.COUNTDOWN_TIMER, targetDate);
    return targetDate;
  }
};
